export const environment = {
	production: true,
	region: 'ap-southeast-2',
	endpoint: 'https://api.reali.au',
	wsEndPoint: 'wss://api.reali.au',
	appName: 'REALI',
	logLevel: 'debug',
	buildId: process.env.NG_APP_BUILD_ID || 'local',
	defaultCollectionLimit: 10,
	enableSentry: true,
	defaultTestEmailAddress: "",
version: "prod_1615",
	baseDomain: 'reali.au',
	readApiToken: "39cafcf2862b2e6627657b726f76d0371fd0e690",
	analyticsTrackingCode: 'G-FX3T1HG3NC',
	GTMTrackingId: 'GTM-MQ8BZ6T6',
	defaultSsoPool: 'ap-southeast-2_QM5ZnkQJw',
	defaultSsoDomain: 'sso.reali.au',
	stripePublishedKey: 'pk_live_51N6jqvS85sBnEhHBiHmMXWqY2p2GoQxFwxxDwivQUICzNZBC1GvB5soj0zuAl84gfNb8JwTC72lm9lt5ZMVtCJcs002SJ6k3go',
	staticAssets: {
		bucket: 'static.reali.au',
		cdnUrl: 'https://static.reali.au',
	},
};
